<div>
	<div class="row align-items-center">
		<div class="col-md-4">
			<mat-form-field class="w-100">
				<mat-label>Szukaj</mat-label>
				<input
					matInput
					name="filters.search"
					[(ngModel)]="filters.search"
					(keydown.enter)="filtersSave()"
					placeholder="Nazwa agenta"
				/>
			</mat-form-field>
		</div>
	</div>
	<div class="row align-items-center">
		<div class="col-md-4">
			<div class="fill-width">
				<mat-form-field class="w-100 pe-2">
					<mat-label>Wybierz termin od</mat-label>
					<input
						matInput
						name="parseFilters.term__gte"
						[ngModel]="parseFilters().term__gte"
						(ngModelChange)="updateParseFilter('term__gte', $event)"
						[matDatepicker]="term__gte"
					/>
					<mat-hint></mat-hint>
					<mat-datepicker-toggle matSuffix [for]="term__gte"></mat-datepicker-toggle>
					<mat-datepicker #term__gte> </mat-datepicker>
				</mat-form-field>
				<mat-form-field class="w-100 ps-2">
					<mat-label>Wybierz termin do</mat-label>
					<input
						matInput
						name="parseFilters.term__lte"
						[ngModel]="parseFilters().term__lte"
						(ngModelChange)="updateParseFilter('term__lte', $event)"
						[matDatepicker]="term__lte"
					/>
					<mat-hint></mat-hint>
					<mat-datepicker-toggle matSuffix [for]="term__lte"></mat-datepicker-toggle>
					<mat-datepicker #term__lte> </mat-datepicker>
				</mat-form-field>
			</div>
		</div>
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="filters.reservation_seller"
				[(ngModel)]="filters.reservation_seller"
				[multiple]="true"
				placeholder="Agent"
			>
				<ng-option *ngFor="let item of agencies()" [value]="item.id">{{ item.shortName }}</ng-option>
			</ng-select>
		</div>
		<div class="col-md-4">
			<mat-form-field class="w-100">
				<mat-label>Numer rezerwacji</mat-label>
				<input matInput [(ngModel)]="filters.table_id__in" placeholder="Numer rezerwacji" />
			</mat-form-field>
		</div>
	</div>
	<div class="row align-items-center">
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="filters.status__in"
				[(ngModel)]="filters.status__in"
				[multiple]="true"
				placeholder="Status"
			>
				<ng-option *ngFor="let item of statusOptions()" [value]="item.id">{{ item.name }}</ng-option>
			</ng-select>
		</div>
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="filters.kind"
				[ngModel]="filters.kind"
				(ngModelChange)="onKindChange($event)"
				[multiple]="false"
				placeholder="Rodzaj"
			>
				<ng-option *ngFor="let item of kindOptions" [value]="item.id">{{ item.name }}</ng-option>
			</ng-select>
		</div>
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="parseFilters.reservation_status"
				[ngModel]="parseFilters().reservation_status"
				(ngModelChange)="updateParseFilter('reservation_status', $event)"
				[multiple]="true"
				placeholder="Status rezerwacji"
			>
				<ng-option *ngFor="let item of reservationStatusOptions" [value]="item.id">{{ item.name }}</ng-option>
			</ng-select>
		</div>
	</div>
	<div class="row align-items-center">
		<div class="col-md-4">
			<div class="fill-width">
				<mat-form-field class="w-100 pe-2">
					<mat-label>Kwota od</mat-label>
					<input
						type="number"
						matInput
						name="parseFilters.value__gte"
						[ngModel]="parseFilters().value__gte"
						(ngModelChange)="updateParseFilter('value__gte', $event)"
						matTooltip="(większa lub równa)"
					/>
				</mat-form-field>
				<mat-form-field class="w-100 ps-2">
					<mat-label>Kwota do</mat-label>
					<input
						type="number"
						matInput
						name="parseFilters.value__lt"
						[ngModel]="parseFilters().value__lt"
						(ngModelChange)="updateParseFilter('value__lt', $event)"
						matTooltip="(mniejsza)"
					/>
				</mat-form-field>
			</div>
		</div>
		<div class="col-md-4">
			<mat-checkbox name="filters.hide_expired_options" [(ngModel)]="filters.hide_expired_options">
				Ukryj wygasłe opcje
			</mat-checkbox>
		</div>
		<div class="col-md-4">
			<div class="text-end mt-3">
				<button class="me-2 mat-button-save-filters" mat-raised-button color="primary" (click)="filtersSave()">
					Pokaż
				</button>
				<button mat-raised-button class="mat-button-clear-all" (click)="filtersClear()">Wyczyść</button>
			</div>
		</div>
	</div>
</div>
